/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=30c7869f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30c7869f&lang=css"

import exportComponent from "C:\\Users\\10938\\Desktop\\ysjf1\\采购\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__